<p bitTypography="body1" class="tw-mb-0">
  {{ "openExtensionFromToolbarPart1" | i18n }}
  <bit-icon
    [icon]="BitwardenIcon"
    class="!tw-inline-block [&>svg]:tw-align-baseline [&>svg]:-tw-mb-[0.25rem]"
  ></bit-icon>
  {{ "openExtensionFromToolbarPart2" | i18n }}
</p>
